import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router';

export default function MarketplaceCheckoutSuccessPage() {
    const navigate = useNavigate();
    return (
        <div className="p-6 flex justify-center">
            <Card className="max-w-md w-full">
                <CardContent className="py-12 text-center space-y-4">
                    <CheckCircle className="w-16 h-16 mx-auto text-emerald-500" />
                    <h2 className="text-xl font-semibold">
                        Subscription Active!
                    </h2>
                    <p className="text-muted-foreground">
                        Your subscription is now active. You can manage it from
                        your subscriptions page.
                    </p>
                    <div className="flex gap-3 justify-center">
                        <Button
                            onClick={() => navigate('/settings/subscriptions')}
                        >
                            View Subscriptions
                        </Button>
                        <Button
                            variant="outline"
                            onClick={() => navigate('/marketplace')}
                        >
                            Back to Marketplace
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
